<h1 class="text-lg font-semibold m-3 text-uppercase text-gray-600" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
    {{ 'SIDEBAR.CARBON'| translate}}
</h1>
<button *ngIf="savedCarbon" class="float-right mx-2 mb-2" mat-raised-button (click)="addCarbonButton()"
    style="background-color: #8deda3;">
    <i class="fa-solid fa-plus"></i>
    {{'CARBON.ADD_CARBON_METRICS' | translate}}
</button>
<form [formGroup]="carbonForm">
    <div class="w-full flex justify-center">
        <mat-card class="w-3/12 mx-3" *ngIf="savedCarbon">
            <mat-card-header class="justify-center text-md fw-bold text-gray-500 mx-2 my-2">
                {{'CARBON.SAVED_CROPS_TITLE' | translate}}
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="savedDataList && savedDataList.length > 0; else noData">
                    <div *ngFor="let data of savedDataList" (click)="fillSoilDataForm(data)" [ngClass]="{
                       'bg-green-100': selectedSoilData === data,
                       'bg-gray-100': selectedSoilData !== data
                    }" class="my-2 p-2 rounded hover:bg-green-100 cursor-pointer transition-all duration-100">
                        <div class="w-full flex justify-between items-center">
                            <div class="flex items-center gap-4" (click)="rowSaved(data)">
                                <div
                                    class="w-5 h-5 p-3 rounded-full bg-green-500 shadow flex justify-center items-center">
                                    <i class="fa-solid fa-leaf text-md text-white"></i>
                                </div>
                                <div>
                                    <div class="text-sm text-gray-600 text-left">
                                        <strong>{{'CARBON.SAVED' | translate}}:</strong> {{ data.datetime | date }}
                                    </div>
                                    <div class="text-sm text-left">
                                        <strong>{{'CARBON.CROP_TYPE' | translate}}:</strong> {{ data.crop_type }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex gap-3 items-center border-l pl-3 border-gray-300">
                                <i class="fa-solid fa-eye cursor-pointer text-lg transition-transform duration-200 hover:scale-125"
                                    style="color: rgb(0, 186, 68, 1);" (click)="showRow(data)">
                                </i>
                                <i class="fa-solid fa-trash cursor-pointer text-lg transition-transform duration-200 hover:scale-125"
                                    style="color: red;" (click)="deleteRow(data)">
                                </i>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #noData>
                    <p class="text-sm text-gray-500 italic">{{'CARBON.NO_SAVED_DATA' | translate}}</p>
                </ng-template>
            </mat-card-content>
        </mat-card>
        <div [ngClass]="savedCarbon ? 'w-9/12' : 'w-full'">
            <mat-card class="p-2 mx-2">
                <mat-tab-group (selectedTabChange)="onTabChange($event)">
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <i class="fa-solid fa-chart-bar mx-2"></i>
                            {{'CARBON.SPECIFIC_CROPS' | translate}}
                        </ng-template>
                        <div class="p-3">
                            <app-carbon-tabs [widgets]="widgets" [barChartOptions]="carbonBarChartOptions"
                                [pieChartOptions]="carbonPieChartOptions">
                            </app-carbon-tabs>
                        </div>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <i class="fa-solid fa-chart-pie mx-2"></i>
                            {{'CARBON.TOTALS' | translate}}
                        </ng-template>
                        <div class="p-3">
                            <app-carbon-tabs [widgets]="widgets" [barChartOptions]="carbonBarChartOptions"
                                [pieChartOptions]="carbonPieChartOptions"
                                [barVerticalChartOptions]="carbonBarVerticalChartOptions"
                                [verticalChart]="selectedTabIndex">
                            </app-carbon-tabs>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>
        </div>
    </div>
</form>